import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges, } from '@angular/core';
import { CareerPositionCard, CareerPositionCardLayoutData, CareerPositionsSorting } from '../career-lobby-page.interfaces';
import { DropdownOption } from '../../../shared/interfaces/dropdown'
import { UserAgentService } from 'src/app/shared/services/user-agent.service';

@Component({
  selector: 'app-career-lobby-positions-list',
  templateUrl: './career-lobby-positions-list.component.html',
  styleUrls: ['./career-lobby-positions-list.component.scss'],
})
export class CareerLobbyPositionsListComponent implements OnInit, OnChanges {
  @Input() resultText?: string;
  @Input() noResultsTitle?: string;
  @Input() noResultsText?: string;
  @Input() noResultsImage?: string;
  @Input() clearAllText?: string;
  @Input() totalSearchResultsCount?: number;
  @Input() pageSize?: number;
  @Input() cards?: CareerPositionCard[];
  @Input() cardLayoutData?: CareerPositionCardLayoutData;
  @Input() currentPage?: number;
  @Input() isLoading!: boolean;
  @Input() isPageLoading!: boolean;
  @Input() sortingByDateOptionTitle: string = '';
  @Input() sortingByTitleOptionTitle: string = '';
  @Input() sortingByTypeOptionTitle: string = '';
  @Input() sortingDropdownPlaceholder: string = '';

  @Input() set sorting (value: CareerPositionsSorting){
    this.sortingOptions.forEach(option => {
      option.isSelected = option.value==value;
     });
     this.selectedSort = value;
  }

  @Output() pageChange = new EventEmitter<number>();
  @Output() openPositionPopup = new EventEmitter<number>();
  @Output() sortingChange = new EventEmitter<CareerPositionsSorting>();
  @Output() clearAllBtnClick = new EventEmitter<void>();
  
  totalPagesCount: number[] = [];
  isLoaded: boolean = false;
  CareerPositionsSorting = CareerPositionsSorting;
  sortingOptions: DropdownOption[] = [];
  rangeSize: number =3;
  selectedSort?: CareerPositionsSorting;
  
  private  isMobile:boolean =false;
    paginatorContainerCssClass=  'pagination';
constructor( private userAgentService: UserAgentService) {
  this.isMobile = userAgentService.isMobileDevice();
  this.rangeSize= this.isMobile?1:3;
  if(this.isMobile)
  {
    this.paginatorContainerCssClass = 'pagination mobile';
  }
 }


  ngOnChanges(changes: SimpleChanges) {
    if(!this.isPageLoading) {
      this.setSortingOptions();
      this.setTotalPage();
    }
  }

  ngOnInit(): void { 
    this.setTotalPage();
    // this.sortingOptions = [
    //   {
    //     name: this.sortingByDateOptionTitle,
    //     value: CareerPositionsSorting.UpdateDate,
    //   },
    //   {
    //     name: this.sortingByTypeOptionTitle,
    //     value: CareerPositionsSorting.Type
    //   },
    //   {
    //     name: this.sortingByTitleOptionTitle,
    //     value: CareerPositionsSorting.Title
    //   }
    // ];
  }
private setSortingOptions(){
  if(this.sortingOptions.length)
  return;
  this.sortingOptions = [
    {
      name: this.sortingByDateOptionTitle,
      value: CareerPositionsSorting.UpdateDate,
    },
    {
      name: this.sortingByTypeOptionTitle,
      value: CareerPositionsSorting.Type
    },
    {
      name: this.sortingByTitleOptionTitle,
      value: CareerPositionsSorting.Title
    }
  ];

  if(this.selectedSort)
    this.sortingOptions.forEach(option => {
      option.isSelected = option.value==this.selectedSort;
    });
}
  private setTotalPage() {
    let totalPages = Math.ceil(this.totalSearchResultsCount! / this.pageSize!);
    this.totalPagesCount = Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  onSortingChange(value: any): void {
    this.sortingChange.emit(value as CareerPositionsSorting);
  }

  goToPage(  pageNumber: number): void {
    if (event) event.preventDefault();
    if (
      this.cards != undefined &&
      pageNumber >= 1 &&
      pageNumber <= Math.ceil(this.totalSearchResultsCount! / this.pageSize!)
    ) {
      this.currentPage = pageNumber;
      this.pageChange.emit(this.currentPage);
    }
  }

  clearAll() {
    this.clearAllBtnClick.emit();
  }

  openPositionPopupHandler(positionId: number) {
    this.openPositionPopup.emit(positionId);
  }
}
